import React, { useState, useEffect } from 'react';

const RecommendationCard = ({ topic }) => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadRecommendations();
  }, [topic]);

  const loadRecommendations = async () => {
    setLoading(true);
    setError('');
    
    try {
      const articleResults = await fetchWikipediaArticles(topic);
      setArticles(articleResults.slice(0, 5));
      setLoading(false);
    } catch (error) {
      console.error('Error loading recommendations:', error);
      setError('Failed to load articles');
      setLoading(false);
    }
  };

  const fetchWikipediaArticles = async (query) => {
    try {
      const response = await fetch(
        `https://en.wikipedia.org/w/api.php?action=query&list=search&srsearch=${encodeURIComponent(query)}&format=json&origin=*&srlimit=5`
      );

      if (!response.ok) {
        throw new Error(`Wikipedia API error: ${response.status}`);
      }

      const data = await response.json();

      return data.query.search.map((result) => ({
        title: result.title,
        snippet: result.snippet.replace(/<[^>]*>/g, ''),
        url: `https://en.wikipedia.org/wiki/${encodeURIComponent(result.title.replace(/ /g, '_'))}`,
      }));
    } catch (error) {
      console.error('Wikipedia API error:', error);
      return [];
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-8">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-8">
        <p className="text-slate-400 mb-4">{error}</p>
        <button onClick={loadRecommendations} className="text-sm text-indigo-400 hover:text-indigo-300">
          Try Again
        </button>
      </div>
    );
  }

  if (articles.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-slate-400">No articles available at the moment</p>
      </div>
    );
  }

  return (
    <div>
      {/* Articles Header */}
      <div className="flex items-center gap-2 mb-4">
        <span className="text-lg">📖</span>
        <h3 className="font-semibold text-slate-300">Wikipedia Articles ({articles.length})</h3>
      </div>

      {/* Articles List */}
      <div className="space-y-3">
        {articles.map((article, index) => (
          <a
            key={index}
            href={article.url}
            target="_blank"
            rel="noopener noreferrer"
            className="block p-4 bg-slate-700 hover:bg-slate-600 rounded-lg transition hover-lift"
          >
            <h4 className="font-medium text-slate-200 mb-2 flex items-center gap-2">
              <span className="text-indigo-400">📄</span>
              {article.title}
            </h4>
            <p className="text-sm text-slate-400 line-clamp-2 leading-relaxed">
              {article.snippet}
            </p>
            <div className="mt-2 flex items-center gap-1 text-xs text-indigo-400">
              <span>Read more</span>
              <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default RecommendationCard;